import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RequestListComponent} from './request-list.component';
import {IonicModule} from '@ionic/angular';
import {RouterModule} from '@angular/router';
import {ReadMoreModule} from '../read-more/read-more.module';

@NgModule({
  declarations: [RequestListComponent],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    ReadMoreModule
  ],
  exports: [RequestListComponent]
})
export class RequestListModule {
}
